import * as Types from '../../../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type CreateProductReminderMutationVariables = Types.Exact<{
  customerReminder: Types.CreateCustomerReminderInput;
}>;


export type CreateProductReminderMutation = { __typename?: 'mutation_root', result: { __typename?: 'SuccessObjectDto', success: boolean } };


export const CreateProductReminderDocument = gql`
    mutation createProductReminder($customerReminder: CreateCustomerReminderInput!) {
  result: nest_createCustomerReminder(customerReminder: $customerReminder) {
    success
  }
}
    `;
export function useCreateProductReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductReminderMutation, CreateProductReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductReminderMutation, CreateProductReminderMutationVariables>(CreateProductReminderDocument, options);
      }
export type CreateProductReminderMutationHookResult = ReturnType<typeof useCreateProductReminderMutation>;
export type CreateProductReminderMutationResult = Apollo.MutationResult<CreateProductReminderMutation>;
export type CreateProductReminderMutationOptions = Apollo.BaseMutationOptions<CreateProductReminderMutation, CreateProductReminderMutationVariables>;